
<kendo-dropdownlist class="val-dashboard-filtre-temporel-dropdown"
										[data]="optionsPeriode"
										[(ngModel)]="periodeSelectionnee"
										(valueChange)="OnPeriodeChange($event)">
	<ng-template kendoDropDownListItemTemplate let-dataItem>
		{{ 'dashboard.filtre-temporel.' + dataItem | transloco }}
	</ng-template>
	<ng-template kendoDropDownListValueTemplate let-dataItem>
		{{ 'dashboard.filtre-temporel.' + periodeSelectionnee | transloco }}
	</ng-template>
</kendo-dropdownlist>
